module.exports = __webpack_public_path__ + "static/media/logout.38afb737.svg";